/**
 * Dedicated Moderation Queue page — admin-only. Renders the AdminReportsCard
 * as a full-page experience so admins can triage reported content without the
 * clutter of the rest of the Admin Settings dashboard.
 *
 * Route: /admin/moderation (see App.js — gated by ProtectedRoute adminOnly).
 */
import AppLayout from "../components/AppLayout";
import AdminReportsCard from "../components/AdminReportsCard";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldAlert } from "lucide-react";

export default function AdminModeration() {
  return (
    <AppLayout>
      <div className="mb-6">
        <Link to="/admin/settings" className="inline-flex items-center gap-1.5 text-[10px] font-mono-num uppercase tracking-widest text-slate-500 hover:text-[#0D9488] mb-3" data-testid="admin-moderation-back">
          <ArrowLeft className="w-3 h-3" /> Admin dashboard
        </Link>
        <div className="flex items-center gap-3">
          <ShieldAlert className="w-6 h-6 text-red-500" />
          <div>
            <div className="font-mono-num text-[11px] uppercase tracking-[0.3em] text-red-500">// Moderation queue</div>
            <h1 className="font-display font-black uppercase tracking-tight text-3xl text-slate-900">Reports</h1>
          </div>
        </div>
        <p className="text-slate-500 mt-3 text-sm max-w-2xl">
          Every reported post, reply, direct message, or user shows up here. Dismiss what's fine,
          Resolve what's addressed, or Remove content that violates community rules. Removing a
          post or message deletes it from the site immediately.
        </p>
      </div>
      <AdminReportsCard />
    </AppLayout>
  );
}
